import cx from 'classnames';
import HeaderDesktopMenu, { HeaderDesktopMenuDrawerProps, HeaderDesktopMenuLinkProps } from '../HeaderDesktopMenu';

type DesktopHeaderProps = {
  isHeaderScrolled: boolean;
  isMobileMenuOpen: boolean;
  forceOpaque?: boolean;
  onMouseLeaveHeader: () => void;
  desktopMenu: (HeaderDesktopMenuDrawerProps | HeaderDesktopMenuLinkProps)[];
  logoColumn: React.ReactNode;
  centerMenuColumn: React.ReactNode;
  rightMenuColumn: React.ReactNode;
}

export const DesktopHeader = ({
  isHeaderScrolled,
  isMobileMenuOpen,
  forceOpaque,
  onMouseLeaveHeader,
  desktopMenu,
  logoColumn,
  centerMenuColumn,
  rightMenuColumn,
}: DesktopHeaderProps) =>
  <header
    className={cx('left-0 right-0 duration-600 ease-appear', {
      'shadow-header-scrolled': isHeaderScrolled && !isMobileMenuOpen,
      'bg-white': isHeaderScrolled || isMobileMenuOpen || forceOpaque,
    })}
    onMouseLeave={onMouseLeaveHeader}
  >
    <div className="px-container-mobile md:px-container-desktop">
      <div className="mx-auto max-w-grid">
        <div className="h-12 md:h-10 flex justify-between items-center">
          {logoColumn}
          {centerMenuColumn}
          {rightMenuColumn}
        </div>
      </div>
    </div>
    <HeaderDesktopMenu menu={desktopMenu} />
  </header>
